var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpuCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.4 20.75h-4.8c-4.39 0-6.35-1.96-6.35-6.35v-4.8c0-4.39 1.96-6.35 6.35-6.35h4.8c4.39 0 6.35 1.96 6.35 6.35v4.8c0 4.39-1.96 6.35-6.35 6.35zm-4.8-16c-3.58 0-4.85 1.27-4.85 4.85v4.8c0 3.58 1.27 4.85 4.85 4.85h4.8c3.58 0 4.85-1.27 4.85-4.85v-4.8c0-3.58-1.27-4.85-4.85-4.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 17.75h-3c-2.9 0-4.25-1.35-4.25-4.25v-3c0-2.9 1.35-4.25 4.25-4.25h3c2.9 0 4.25 1.35 4.25 4.25v3c0 2.9-1.35 4.25-4.25 4.25zm-3-10c-2.08 0-2.75.67-2.75 2.75v3c0 2.08.67 2.75 2.75 2.75h3c2.08 0 2.75-.67 2.75-2.75v-3c0-2.08-.67-2.75-2.75-2.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.00977 4.75c-.42 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 4.75c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16 4.75c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22 8.75h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22 12.75h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m22 16.75h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16 22.75c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m12.0098 22.75c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m8.00977 22.75c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m4 8.75h-2c-.41 0-.75-.33-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m4 12.75h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m4 16.75h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.33.75-.75.75z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9996 15.05c-.13 0-.26-.03-.37-.1-.36-.21-.48-.67-.28-1.02l.68-1.18h-.59c-.48 0-.87-.21-1.08-.57s-.19-.81.04-1.22l.94-1.64005c.21-.36.67-.48 1.02-.28.36.21.48.67.28 1.02005l-.68 1.18h.59c.48 0 .87.21 1.08.57s.19.81-.04 1.22l-.94 1.64c-.14.25-.39.38-.65.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuCharge);
export default __webpack_public_path__ + "static/media/cpu-charge.433ae507f592fc7a60abb485254898c4.svg";
export { ForwardRef as ReactComponent };